import { post } from "@insite/client-framework/Services/ApiService";

export const removeInvalidItems = async (paramaters: string[]) => {
    const response = await post<any>("/api/v2/Cart/RemoveInvalidPriceCartLine", paramaters);
    return response;
};
